<template>
<div>
  <v-application>
    <v-row no-gutters>
      <v-col
          cols="12"
          sm="6"
          md="8">
    <v-card class="ms-3">
      <p style="margin-left: 30px; color: grey; padding-top: 30px; font-size: 25px" class="mt-5">Товары</p>
      <div>
        <p style="margin-left: 20px; color: grey; font-size: 20px">Tovari</p>
      </div>
      <v-divider />
      <div>
        <v-data-table
            :headers="headers"
            :items="desserts"
            hide-default-header
            hide-default-footer
            class="elevation-1"
        ></v-data-table>
      </div>
    </v-card>
      </v-col>
      <v-col
          cols="6"
          md="4">
        <v-card class="mt-2" style="width: 90%; margin-left: 15px">
          <p class="add-text mt-5">SO00478</p>
            <v-divider />
          <div class="ms-3">
            <p style="font-size: 20px; font-weight: normal">Client</p>
          </div>
          <div class="ms-1">
            <v-text-field
                v-model="name"
                label="Имя или номер телефона"
                class="text-field"
                style="width: 98%;"
                required
                outlined
            ></v-text-field>
          </div>
          <div>
            <v-row>
              <v-col
                  cols="12"
                  sm="6"
                  md="5"
                  class="ms-3">

              <v-btn
                  class="ms-1"
                  depressed
                  style="width: 100%;
                         background-color: #f2f2f2">
                <v-icon medium>
                  mdi-account-plus
                </v-icon>
               <p class="mt-4 me-1 ms-1"> Новый клиент</p>
              </v-btn>
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  md="6">
              <v-btn
                  depressed
                  class="me-2"
                  style="width: 100%;
                         background-color: #f2f2f2"
              >
                <v-icon medium>
                  mdi-credit-card
                </v-icon>
                <p class="mt-4 me-1 ms-1"> Сканировать карту</p>
              </v-btn>
              </v-col>
            </v-row>
            <v-divider class="mt-1" />
            <div class="mt-3" style="margin-left: 10px">
              <p style="font-size: 20px; font-weight: normal">Тип оплаты</p>
            </div>
            <div class="ms-1">
              <v-combobox
                  outlined
                  label="Перечисление"
                  style="width: 98%"
              ></v-combobox>
            </div>
          </div>
          <div style="height: 220px">
          </div>
          <div>
            <v-row>
              <v-col class="ms-4">
                <p style="font-size: 18px">Подитог</p>
              </v-col>
              <v-col>
                <p style="display: flex; justify-content: end; align-items: end;font-size: 18px" class="me-4">
                  10000
                </p>
              </v-col>
            </v-row>
            <v-divider class="mt-2" />
            <div class="mt-3">
              <v-row>
                <v-col class="ms-4">
                  <p style="font-size: 18px">Итог</p>
                </v-col>
                <v-col>
                  <p style="display: flex; justify-content: end; align-items: end; font-size: 18px" class="me-4">
                    10000
                  </p>
                </v-col>
              </v-row>
            </div>
            <div>
              <v-btn color="primary" class="pay-btn" style="height: 70px">
                <v-row>
                  <v-col>
                    <p class="mt-4 justify-start d-flex" style="font-size: 20px">Оплатить</p>
                  </v-col>
                  <v-col>
                    <p class="mt-4 justify-end d-flex"  style="font-size: 20px">10000</p>
                  </v-col>
                </v-row>
              </v-btn>
            </div>
          </div>
          <div>
            <v-btn style="height: 53px ;color: grey; width: 100%">
              <p class="mt-3" style="font-size: 16px">Отложить</p>
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-application>
</div>
</template>

<script>
export default {
  name: "SalesCreate",
  data(){
    return{
      name:''
    }
  }
}
</script>

<style scoped>
.add-text{
  margin-left: 10px;
  font-weight: normal;
  font-size: 20px;
  padding-top: 20px;
}
.pay-btn{
  width: 100%;
}
p{
  font-family: "Roboto", Roboto, sans-serif;
}
</style>